<template>
  <div>
    <p>{{ t('adjustPhDescription') }}</p>
    <!-- Table content remains the same -->
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('startPh')"
          v-model.number="startpH"
        />
        <GenericInput
          :input-label="t('startVolume')"
          v-model.number="startVolume"
          :conversion-factors="ConversionFactors.volume"
        />
        <FixedUnitInput
          :input-label="t('desiredPh')"
          v-model.number="desiredpH"
        />
        <FixedUnitInput
          :input-label="t('additivePh')"
          v-model.number="additivepH"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('startMolarity')"
          :number="startMolarity / 1e-6"
          :unit="t('micromoles')"
        />
        <FixedUnitOutput
          :output-label="t('additiveMolarity')"
          :number="additiveMolarity / 1e-6"
          :unit="t('micromoles')"
        />
        <FixedUnitOutput
          :output-label="t('desiredMolarity')"
          :number="desiredMolarity / 1e-6"
          :unit="t('micromoles')"
        />
        <GenericOutput
          :output-label="t('additiveVolume')"
          :number="additiveVolume"
          :conversion-factors="ConversionFactors.volume"
          :showSplitter="false"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive  } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      GenericInput,
      FixedUnitOutput,
      GenericOutput,
      EquationBlock,
    },
    setup() {
      const startpH = ref(8);
      const startVolume = ref(10);
      const additivepH = ref(6);
      const desiredpH = ref(7);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('phConvEquations');
      });

      const startMolarity = computed(() => Math.pow(10, startpH.value * -1));
      const additiveMolarity = computed(() => Math.pow(10, additivepH.value * -1));
      const desiredMolarity = computed(() => Math.pow(10, desiredpH.value * -1));
  
      const additiveVolume = computed(() => {
        const diffMolarity = desiredMolarity.value - startMolarity.value;
        return diffMolarity * startVolume.value / (additiveMolarity.value - startMolarity.value);
      });
  
      return {
        startpH,
        startVolume,
        additivepH,
        desiredpH,
        startMolarity,
        additiveMolarity,
        desiredMolarity,
        additiveVolume,
        ConversionFactors,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  